import { useState } from 'react';

// components
import IconBurger from '../icons/burger';
import IconDoubleArrowLeft from '../icons/double-arrow-left';
import IconDoubleArrowRight from '../icons/double-arrow-right';
import { SidebarTypes } from './types';

// styles
import styles from './sidebar.module.css';

export default function Sidebar({ children }: SidebarTypes): React.JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleOpen = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div
      className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''} `}
    >
      <button
        type="button"
        className={styles.sidebarToggleButton}
        onClick={toggleOpen}
        aria-label="Toggle"
      >
        <IconDoubleArrowLeft />
        <IconDoubleArrowRight />
        <IconBurger />
      </button>
      <div className={styles.sidebarLinks}>{children}</div>
    </div>
  );
}
